<template>
  <div>
    <v-chip class="border text-uppercase rounded-xxs grey-darken-1--text font-weight-bold">
      {{ $t('videoTherapy.pilot') }}
    </v-chip>
    <div class="mt-6">
      {{ $t('videoTherapy.infoStep.perex') }}
    </div>
    <div class="my-6">
      <v-list class="pa-4 grey rounded">
        <v-list-item
          v-for="(item, index) in bulletPoints"
          :key="index"
          class="pa-0 align-flexstart"
          :class="{ 'mt-4': index > 0 }"
        >
          <v-img :src="$asset(`img/icons/${item.icon}.svg`)" contain width="48" />
          <div class="ml-4 text-left">{{ item.text }}</div>
        </v-list-item>
      </v-list>
      <div
        v-if="$te('videoTherapy.infoStep.therapist.title')"
        class="mt-8 d-flex flex-column align-start"
      >
        <div class="text-h3">
          {{ $t('videoTherapy.infoStep.therapist.title') }}
        </div>
        <div class="d-flex flex-row mt-4">
          <v-img
            :src="$asset(`img/people/${$t('videoTherapy.infoStep.therapist.image')}`)"
            contain
            max-width="48"
            height="48"
            class="rounded-circle"
          />
          <div class="d-flex flex-column ml-4 align-start text-left">
            <div class="text-h4">{{ $t('videoTherapy.infoStep.therapist.name') }}</div>
            <div class="text-body-small grey-darken-1--text font-weight-bold mt-2">
              {{ $t('videoTherapy.infoStep.therapist.specialization') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <p
      v-for="(item, index) in texts"
      :id="'videoTherapyLegals' + `[${index}]`"
      :key="index"
      class="grey-darken-1--text text-body-small text-left"
      v-html="item"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import dashboardPartnerData from '@/mixins/dashboardPartnerData.js';

export default {
  name: 'VideoTherapyInfoStep',
  mixins: [dashboardPartnerData],
  data() {
    return {
      bulletPoints: [
        {
          icon: 'register',
          text: this.$t('videoTherapy.infoStep.list.first')
        },
        {
          icon: `calendar/date-${new Date().getDate()}`,
          text: this.$t('videoTherapy.infoStep.list.second')
        },
        {
          icon: 'doctor',
          text: this.$t('videoTherapy.infoStep.list.third')
        }
      ]
    };
  },
  computed: {
    isAllianz() {
      //hack for cs allianz legal document change, can be deleted when not needed
      return this.partnerData.url === 'allianzlegal' && this.$i18n.locale === 'cs';
    },
    allianzTexts() {
      //hack for cs allianz legal document change, can be deleted when not needed
      return [
        'Vezměte, prosím, na vědomí, že služba Videohovor s lékařem má pouze informativní charakter.',
        'Jedná se o obecné rady a informace z oblasti zdraví, nemocí či jiných zdravotních obtíží. Výše uvedené informace nemohou být považovány za určení individuální diagnózy, stanovení léčebného plánu či plánu prevence, a to zejména s ohledem na omezené možnosti online komunikace. Vzhledem k tomu, že informace od uživatele nemohou být úplné a tělesné vyšetření není možné, odpovědi jednotlivých lékařů se mohou v detailech lišit v závislosti na jejich zkušenostech a klinické praxi.',
        'Využití služby v žádném případě nenahrazuje osobní vyšetření lékařem. V případě zdravotních obtíží doporučujeme vyhledat lékařskou či jinou odbornou péči podle povahy potíží.'
      ];
    },
    texts() {
      const lokaliseTexts = this.$t('videoTherapy.infoStep.legal');
      if (this.isAllianz) {
        return [lokaliseTexts[0], ...this.allianzTexts];
      }

      return lokaliseTexts;
    }
  },
  mounted() {
    if (this.isAllianz) {
      const elements = document.querySelectorAll('[id^="videoCallLegals"]'); //hack for cs allianz legal document change, can be deleted when not needed
      elements.forEach((el, index) => {
        el.textContent = this.allianzTexts[index];
      });
    }
    this.setDialogTitle(this.$t('videoTherapy.infoStep.title'));
    this.setDialogLeftHeaderIcon('icons/brain.svg');
    this.setDialogButtons([
      {
        events: {
          click: () => {
            this.$emit('next-click');
          }
        },
        text: this.$t('videoCall.infoStep.button')
      }
    ]);
  },
  methods: {
    ...mapActions({
      setDialogTitle: 'staticForms/videoTherapy/infoStep/setDialogTitle',
      setDialogButtons: 'staticForms/videoTherapy/infoStep/setDialogButtons',
      setDialogLeftHeaderIcon: 'staticForms/videoTherapy/infoStep/setDialogLeftHeaderIcon'
    })
  }
};
</script>

<style scoped>
.v-chip {
  pointer-events: none;
}
</style>
